import { Language } from "../constants/language";

export class Translation {
    english: string;
    key: string;
    code: Language;
    isHtml?: boolean;

    constructor() {
        this.english = null;
        this.key = null;
        this.code = Language.en;
        this.isHtml = false;
    }
}

export class TranslateModel {
    translation: string;

    constructor() {
        this.translation = null;
    }
}

export class SupportedLanguage {
    code: Language;
    description: string;

    constructor() {
        this.code = Language.en;
        this.description = null;
    }
}

export class PreferedLanguagePayload {
    languageCode: string;
    systemNumber: number;

    constructor() {
        this.languageCode = '';
        this.systemNumber = 0;
    }
}